module.exports = __webpack_public_path__ + "static/media/tasks.2549afdc.svg";